module.exports = __webpack_public_path__ + "img/text-underline.85aa95d4.svg";